import styled from "styled-components";
import { Breakpoints } from "../AppTheme";

export const StyledSearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  white-space: nowrap;

  #searchDiv-source-menu-button {
    display: none;
  }

  #searchDiv-suggest-menu {
    width: 20rem;
  }

  #searchDiv {
    flex: 1 1 auto;
    min-width: 0;
    width: auto;
    margin-inline-end: 0.5rem;
  }

  #myloc-btn {
    flex: 0 0 auto;
    min-width: 2.5rem;
    --calcite-ui-brand: white;
    //var(--calcite-ui-foreground-1) is background color
  }

  /* This stops mobile browsers from auto-zooming when focus is in the input box */
  .esri-search__input {
    font-size: 16px;
  }

  @media ${Breakpoints.mobile} {
    width: 100%;
    max-width: 100%;
    min-width: 290px;

    #searchDiv {
      margin-inline-end: 0.25rem;
    }

    #searchDiv-suggest-menu {
      width: 100%;
      max-width: 100%;
    }
  }
`;

export const StyledSearchWrapperText = styled.span`
  margin-inline-end: 0.5rem;
  color: var(--lib-foreground);
`;
